import common from '../../src/common/common';
import edito from '../../src/components/edito';
import accordion from "../../src/components/accordion";

common();
edito();
accordion();
